export default "__VITE_PUBLIC_ASSET__290311ba__"